var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"banner-item",style:(_vm.style),attrs:{"target":"_blank","href":_vm.url,"rel":"noopener nofollow"}},[_c('img',{staticClass:"banner-item__image",attrs:{"loading":"lazy","src":_vm.src,"alt":_vm.banner.link}})])}
var staticRenderFns = []

export { render, staticRenderFns }